import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/effect-fade";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import "../../../styles/Banner.css";
import BannerManagerService from "../../../services/home/BannerManager";
import config from "../../../config";

export default function Banner() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    BannerManagerService.getAllBanners()
      .then((data) => {
        const filtered = data.filter(
          (b) =>
            b.position === "TOP" &&
            b.platform === "WEB" &&
            (b.bannerType === "OFFER" ||
              b.bannerType === "MEMBERSHIP" ||
              b.bannerType === "WELCOME" ||
              b.bannerType === "EXPLORE" ||
              b.bannerType === "BOOK" ||
              b.bannerType === "AUTHOR" ||
              b.bannerType === "CATEGORY")
        );
        setBanners(filtered);
      })
      .catch((err) => console.error("Failed to load banners", err));
  }, []);

  if (!banners.length) {
    return (
      <div className="min-h-[300px] sm:min-h-[400px] lg:min-h-[480px] flex items-center justify-center bg-primary-shade1">
        <p className="text-gray-500">Loading banners…</p>
      </div>
    );
  }

  return (
    <div className="relative w-full overflow-hidden">
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        navigation
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={800}
        autoHeight={true}
      >
        {banners.map((b) => {
          const bannerContent = (
            <>
              <img
                src={`${config.url}/bannerImage/${b.bannerImage}`}
                alt={b.bannerHeading}
                className="w-full h-auto object-cover block"
              />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white p-4">
                <h2 className="text-xl sm:text-3xl lg:text-5xl font-bold mb-2 drop-shadow-md">
                  {b.bannerHeading}
                </h2>
                {b.bannerHighlight && (
                  <p className="text-base sm:text-xl lg:text-2xl mb-4 drop-shadow">
                    {b.bannerHighlight}
                  </p>
                )}
                {b.bannerType === "WELCOME" && (
                 <Link
                 to={b.bannerCtaBtnLink || "/signup"}
                 className="absolute bottom-2 sm:bottom-10 px-5 sm:px-6 sm:py-3 bg-primary text-white rounded-lg text-xs sm:text-sm lg:text-base font-semibold shadow-md hover:bg-primary-dark transition"
                 style={{ left: "50%", transform: "translateX(-50%)" }}
               >
                 Sign Up
               </Link>
                )}
              </div>
            </>
          );

          const Wrapper = ({ children }) => {
            if (b.bannerCtaBtnLink) {
              return (
                <Link
                  to={b.bannerCtaBtnLink}
                  className="block relative w-full h-full cursor-pointer"
                >
                  {children}
                </Link>
              );
            } else if (b.bookId) {
              return (
                <Link
                  to={`/book/${b.bookId}`}
                  className="block relative w-full h-full cursor-pointer"
                >
                  {children}
                </Link>
              );
            } else {
              return <div className="relative w-full h-full">{children}</div>;
            }
          };

          return (
            <SwiperSlide key={b.bannerId}>
              <Wrapper>{bannerContent}</Wrapper>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
